/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, LogLevel } from "@azure/msal-browser";
import Context from './context'
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig:Configuration = {
    auth: {
        clientId: "7b2c3286-c146-4e05-b0ce-fb49cf31241f",
        //clientId: "5d642353-3cfc-480f-a051-700d8b835ea8",
        // authority: "https://login.microsoftonline.com/accdaf17-5bdf-449c-8835-ecd3fd375915/",
        authority: "https://login.microsoftonline.com/common/",
        knownAuthorities: ["https://login.microsoftonline.com/common/"],
        redirectUri: Context.AuthRedirectUri + "/login"
    },
    // auth: {
    //     clientId: "4829629c-4ae8-42a5-9def-bd28fbfd6992",
    //     authority: "https://joakimekebladhotmail.b2clogin.com/92800de7-7ae6-44a9-af1a-1df157dd67e5/B2X_1_ekeblad2019_test",
    //     knownAuthorities: ["https://joakimekebladhotmail.b2clogin.com"],
    //     redirectUri: "http://localhost:3000/"
    // },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    // case LogLevel.Info:
                    //     console.debug(message);
                    //     return;
                    // case LogLevel.Verbose:
                    //     console.debug(message);
                    //     return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */

// export const loginScopes: string[] = ["api://api.customerportal.avonova.se/login"];
export const loginScopes: string[] = ["api://api.customerportal.avonova.se/.default", "openid"];
// export const loginScopes: string[] = ["profile", "email", "openid"];

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me"
};